import { useAmp } from 'next/amp'
import { useRouter } from 'next/router'
import Script from 'next/script'

export const GA_TRACKING_ID = 'UA-46926915-1'
export const GLOBAL_GA_TRACKING_ID = 'UA-46926915-13'

const GoogleAnalytics = () => {
	const isAmp = useAmp()
	const router = useRouter()

	if (process.env.NODE_ENV !== 'production') {
		return null
	}

	const GA_ID =
		router.locale !== router.defaultLocale
			? GLOBAL_GA_TRACKING_ID
			: GA_TRACKING_ID

	return (
		<>
			{isAmp ? (
				<script
					async
					custom-element="amp-analytics"
					src="https://cdn.ampproject.org/v0/amp-analytics-0.1.js"
				></script>
			) : process.browser ? (
				<>
					<Script
						strategy="afterInteractive"
						src={`https://www.googletagmanager.com/gtag/js?id=${GA_ID}`}
					/>
					<Script
						id="gtag-init"
						strategy="afterInteractive"
						dangerouslySetInnerHTML={{
							__html: `window.dataLayer = window.dataLayer || [];
				                              function gtag(){dataLayer.push(arguments);}
				                              gtag("js", new Date());

				                              gtag('config', '${GA_ID}', {
												page_path: window.location.pathname,
											  });`,
						}}
					/>
				</>
			) : null}
			{isAmp ? (
				<>
					<amp-analytics type="gtag" data-credentials="include">
						<script
							type="application/json"
							dangerouslySetInnerHTML={{
								__html: `{
									"vars": {
										"gtag_id": "${GA_ID}",
										"config": {
										"${GA_ID}": { "groups": "default", "site_speed_sample_rate": 100 }
										}
									}
								}`,
							}}
						/>
					</amp-analytics>
				</>
			) : null}
		</>
	)
}

export default GoogleAnalytics
